import { HTMLAttributes } from "react";

export type ImageFallbackType =
  | "product-badge"
  | "product-hero"
  | "supplier-badge"
  | "supplier-hero";

export interface ImageWithFallbackProps extends HTMLAttributes<HTMLImageElement> {
  img: string | null | undefined;
  fallback: ImageFallbackType;
}

export const productBadgeFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/product-badge-empty.svg";

export const supplierBadgeFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/supplier-badge-empty.svg";

export const productHeroFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/product-hero-empty.svg";

export const supplierHeroFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/supplier-hero-empty.svg";

export const setFallbackImage = ({
  img,
  fallback,
}: {
  img: ImageWithFallbackProps["img"];
  fallback?: ImageFallbackType;
}) => {
  if (img || !fallback) return img;
  if (!img) {
    switch (fallback) {
      case "product-badge":
        return productBadgeFallback;

      case "product-hero":
        return productHeroFallback;

      case "supplier-badge":
        return supplierBadgeFallback;

      case "supplier-hero":
        return supplierHeroFallback;

      default:
        return productBadgeFallback;
    }
  }
};
